import {Box} from "@cloudscape-design/components";
import {PropsWithChildren} from "react";

export function ValueWithLabel(props: PropsWithChildren<{label : string}>)
{
    return <div>
        <Box variant="awsui-key-label">{props.label}</Box>
        <div>{props.children}</div>
    </div>
}